import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainDisableCard(params) {
  return maintainRequest({
    url: `/user/maintenanceMan/card/disableCard`,
    method: "post",
    params: params,
  });
}
